import {
  FaXTwitter,
  FaGithub,
  FaLinkedin,
  FaInstagram,
  FaDiscord,
} from "react-icons/fa6";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const resources = [
    { name: "Docs", link: "#" },
    { name: "Privacy Policy", link: "#" },
    { name: "Terms of Service", link: "#" },
  ];

  const socials = [
    {
      name: "X (Twitter)",
      link: "https://x.com/Himanshu_ji003",
      icon: FaXTwitter,
    },
    {
      name: "GitHub",
      link: "https://github.com/himanshuji003",
      icon: FaGithub,
    },
    {
      name: "LinkedIn",
      link: "https://www.linkedin.com/in/himanshu-kushwaha-a84869237/",
      icon: FaLinkedin,
    },
    {
      name: "Instagram",
      link: "https://instagram.com/himanshuji003",
      icon: FaInstagram,
    },
    {
      name: "Discord",
      link: "https://discord.com/himanshu_ji003/",
      icon: FaDiscord,
    },
  ];

  const renderLink = (item) => {
    const IconComponent = item.icon;
    return (
      <a
        key={item.name}
        href={item.link}
        className="group flex items-center gap-2 text-gray-400 hover:text-white transition-all duration-300 relative overflow-hidden"
      >
        {item.icon && (
          <IconComponent className="text-lg group-hover:scale-110 transition-transform" />
        )}
        <span className="relative">
          {item.name}
          <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-linear-to-r from-orange-400 to-cyan-400 group-hover:w-full transition-all duration-300" />
        </span>
      </a>
    );
  };

  return (
    <footer className="relative bg-black/95 backdrop-blur-md border-t border-white/10 text-gray-400 overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom,rgba(255,180,80,0.05),transparent_70%)]" />

      <div className="relative mx-auto max-w-7xl px-6 py-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-4">
          {/* Brand Section */}
          <div className="animate-slide-left">
            <h2 className="text-2xl font-bold text-transparent bg-linear-to-r from-orange-400 to-cyan-400 bg-clip-text mb-3">
              Himanshu
            </h2>
            <p className="text-sm text-gray-400">Full-Stack Developer</p>
            <p className="text-xs mt-6 text-gray-600">
              © 2026 Himanshu. All rights reserved.
            </p>
          </div>

          {/* Resources */}
          <div
            className="animate-slide-left"
            style={{ animationDelay: "0.1s" }}
          >
            <h3 className="text-sm font-bold text-white mb-4 uppercase tracking-wider">
              Resources
            </h3>
            <ul className="space-y-3">{resources.map(renderLink)}</ul>
          </div>

          {/* Social */}
          <div className="col-span-2 animate-slide-right">
            <h3 className="text-sm font-bold text-white mb-4 uppercase tracking-wider">
              Connect
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
              {socials.map(renderLink)}
            </div>
          </div>
        </div>

        {/* Bottom Divider */}
        <div className="mt-12 border-t border-white/10 pt-6 flex justify-center items-center gap-4">
          <span className="text-xs text-gray-500">Built with ❤️ Himanshu</span>
          <button
            onClick={scrollToTop}
            className="text-xs text-gray-400 hover:text-white transition-colors duration-300"
          >
            ↑ Back to Top
          </button>
        </div>
      </div>
    </footer>
  );
}
